import axiosClient from "../lib/api/axiosClient";
const endpoint_two = process.env.REACT_APP_API_ENDPOINT_TWO;
const endpoint_one = process.env.REACT_APP_API_ENDPOINT_ONE;
const api_version = process.env.REACT_APP_API_VERSION;

export default {
  getQAStatus: (token, schoolId, status, SearchText, PageSize, PageNumber) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/QualityAssurance/students-admissions?SchoolId=${schoolId}&Status=${status}&SearchText=${SearchText}&PageSize=${PageSize}&PageNumber=${PageNumber}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  changeAdmissionStatus: async (token, admissionIds, status) => {
    // const admissionIdParams = admissionIds.map(id => `admissionIds=${id}`).join('&');

    try {
      const res = await axiosClient.patch(
        `${endpoint_two}/api/v${api_version}/qualityAssurance/change-admission-status?admissionId=${admissionIds}&status=${status}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            accept: "text/plain"
          }
        }
      );
      return res.data;
    } catch (err) {
      console.error("Error changing admission status:", err);
      return err.response;
    }
  },
  getStudentDetails: (token, schoolId, phoneNumber) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/QualityAssurance/view-student-details?phoneNumber=${phoneNumber}&schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  //School Calendar Activities

  getQAActivities: (token, SearchText, PageSize, PageNumber, CalenderId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/SchoolCalendarActivity/fetch-activities?SearchText=${SearchText}&PageSize=${PageSize}&PageNumber=${PageNumber}&CalendarId=${CalenderId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  getQASingleActivity: (token, activityId) =>
    axiosClient
      .get(
        `${endpoint_two}/api/v${api_version}/SchoolCalendarActivity/fetch-activity?activityId=${activityId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  deleteQAActivity: (token, activityId) =>
    axiosClient
      .delete(
        `${endpoint_two}/api/v${api_version}/SchoolCalendarActivity/delete-activity?activityId=${activityId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => res.data)
      .catch((err) => err.response),

  addActivities: (token, data) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/SchoolCalendarActivity/add-activity`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  updateActivities: (token, data) =>
    axiosClient
      .put(`${endpoint_two}/api/v${api_version}/SchoolCalendarActivity/add-activity`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  // Calendar API
  createCalendar: (token, data) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/SchoolCalendarActivity/add-calendar`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  updateCalendar: (token, data) =>
    axiosClient
      .put(`${endpoint_two}/api/v${api_version}/SchoolCalendarActivity/update-calendar`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  deleteCalendar: (token, calendarId) =>
    axiosClient
      .delete(`${endpoint_two}/api/v${api_version}/SchoolCalendarActivity/delete-calendar?calendarId=${calendarId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  updateCalendarStatus: (token, id, Status) =>
    axiosClient.put(
      `${endpoint_two}/api/v${api_version}/SchoolCalendarActivity/update-calendar-status?Id=${id}&Status=${Status}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.data)
      .catch((err) => err.response),


  getCalendars: (token, searchText, pageSize, pageNumber) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/SchoolCalendarActivity/fetch-calendars?SearchText=${searchText}&PageSize=${pageSize}&PageNumber=${pageNumber}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),


  getSingleCalendars: (token, calendarId) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/SchoolCalendarActivity/fetch-calendar?calendarId=${calendarId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),
  //Timetable Api

  getTimeTable: (token, sessionId, classId, searchText, pageSize, pageNumber) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/QualityAssurance/timetable-setups?SessionId=${sessionId}&ClassId=${classId}&SearchText=${searchText}&PageSize=${pageSize}&PageNumber=${pageNumber}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  getTimeTablePreview: (token, sessionId, classId) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/QualityAssurance/timetable-periods-preview?SessionId=${sessionId}&ClassId=${classId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  getTimeTableSetup: (token, setupId) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/QualityAssurance/timetable-setup?setupId=1${setupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),


  updateTimeTableSetup: (token, setupId, payload) =>
    axiosClient
      .patch(`${endpoint_two}/api/v${api_version}/QualityAssurance/update-timetable-setup?setupId=${setupId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  updateTimeTableStatus: (token, setupId, isActivate) =>
    axiosClient
      .patch(`${endpoint_two}/api/v${api_version}/QualityAssurance/activate-deactivate-timetable-setup?setupId=${setupId}&isActivate=${isActivate}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  createTimeTableSetup: (token, payload) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/QualityAssurance/create-timetable-setup`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  deleteTimeTableSetup: (token, setupId) =>
    axiosClient
      .delete(`${endpoint_two}/api/v${api_version}/QualityAssurance/delete-timetable-setup?setupId=${setupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  getTimeTableTimeSlot: (token, setupId) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/QualityAssurance/timeslots?setupId=${setupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  getTimeTableTimePeriod: (token, setupId) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/QualityAssurance/timetable-periods?setupId=${setupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  createTimeTableTimeSlot: (token, payload) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/QualityAssurance/create-update-timeslot`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  createTimeTableTimePeriod: (token, payload) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/QualityAssurance/create-update-timetable-periods`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  createTimeTableSpecialPeriod: (token, payload) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/QualityAssurance/create-update-period-slot`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  getTimeTableTimeSpecialPeriod: (token, setupId) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/QualityAssurance/period-slots?setupId=${setupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  getSchoolProfile: (token, schoolId) =>
    axiosClient
      .get(`${endpoint_one}/api/v${api_version}/Website/GetSchoolProfile/${schoolId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .catch((err) => err.response),

  //Book vendor

  createVendor: (token, payload) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/QualityAssurance/Add-Update-Vendor`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  getVendor: (token) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/QualityAssurance/Vendors`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  deleteVendor: (token, vendorId) =>
    axiosClient
      .delete(`${endpoint_two}/api/v${api_version}/QualityAssurance/DeleteVendor/${vendorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),


  createBook: (token, payload) =>
    axiosClient
      .post(`${endpoint_two}/api/v${api_version}/QualityAssurance/Addbook`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  updateBook: (token, payload) =>
    axiosClient
      .patch(`${endpoint_two}/api/v${api_version}/QualityAssurance/updatebook`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  getBook: async (token, filters, vendorId) => {
    try {
      let url = `${endpoint_two}/api/v${api_version}/QualityAssurance/books`;

      const params = new URLSearchParams();

      if (filters) params.append("filters", encodeURIComponent(filters));
      if (vendorId) params.append("vendorId", vendorId);

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const res = await axiosClient.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res.data;
    } catch (err) {
      return err.response;
    }
  },

  getBookDetails: (token, id) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/QualityAssurance/bookDetails?Id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  deleteBook: (token, bookId) =>
    axiosClient
      .delete(`${endpoint_two}/api/v${api_version}/QualityAssurance/book?bookId=${bookId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),


  //Payment
  getPayments: (token, schoolId) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/QualityAssurance/PaymentProofs?schoolId=${schoolId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  getPaymentDetails: (token, ItemId, paymentReference) =>
    axiosClient
      .get(`${endpoint_two}/api/v${api_version}/QualityAssurance/PaymentProofDetails?ItemId=${ItemId}&paymentReference=${paymentReference}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),

  approvePayment: (token, ItemId, paymentReference) =>
    axiosClient
      .patch(`${endpoint_two}/api/v${api_version}/QualityAssurance/Approve-Payment?ItemId=${ItemId}&paymentReference=${paymentReference}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      .then((res) => res.data)
      .catch((err) => err.response),
}
